<template>
	<div v-if="reportCharts.length>0">
    	<div class="container p-0">
      		<div class="grid-container mb-3">
        		<div class="select-chart">
          			<i class="fal fa-spinner fa-spin" v-if="blockSelect"></i>
          			<select name="" id="" v-model="days" :disabled="blockSelect" size="1">
            			<option value="365">Último ano</option>
            			<option value="90">Últimos 90 dias</option>
            			<option value="30">Últimos 30 dias</option>
						<option value="7">Últimos 7 dias</option>
          			</select>
        		</div>
				<div class="date-chart">
					<span>{{ datechart }}</span>
        		</div>
        		<div class="chart-area" v-if="chartLoaded">
          			<ReportChart :color="colorFranchise" :chartData="reportCharts[0]" />
        		</div>
        		<div
          			class="card-opportunities"
          			v-for="card in filterOpportunities"
          			:key="card.reportTitle"
				>
          			<ReportCard>
            		<p slot="card-title" style="text-align: center" class="report-card-title m-0">{{ card.reportTitle }}</p>
					<p slot="card-value" style="text-align: center; font-size: 36px; color: black" class="report-card-value extra-size m-0" >{{ card.reportValue }}</p>
					<span slot="card-percentage" style="text-align: center" class="percentage-value">{{ card.conversionRate | toPercentage }}</span>
            		<template slot="card-report-list">
              			<ul class="mb-4 text-center">
                			<li v-for="item in filterReportListValue(card.reportList)" :key="item.interactionOriginName" style="font-size: 12px">
                  				<strong>{{ item.interactionOriginValue }}</strong> {{ item.interactionOriginName }}
                			</li>
              			</ul>
            		</template>
          			</ReportCard>
        		</div>
				<!-- <div class="card-interactions" v-for="card in filterInteractions" :key="card.reportTitle">
          			<ReportCard>
						<p slot="card-value" class="report-card-value m-0 opacity-80" v-if="card.reportValue > 0">{{ card.reportValue }}</p>
						<p slot="card-title" class="report-card-title m-0">{{ card.reportTitle }}</p>
						<span slot="card-percentage" class="percentage-value">{{ card.conversionRate | toPercentage }}</span>
						<template slot="card-report-list" v-if="card.reportList.length > 0">
							<div class="row mb-3">
								<div class="col-12 text-left">
									<ul class="mt-4">
										<li v-for="item in filterReportListValue(card.reportList)" :key="item.interactionOriginName">
											<strong>{{ item.interactionOriginValue }}</strong> em {{ item.interactionOriginName }}
										</li>
									</ul>
								</div>
							</div>
						</template>
          			</ReportCard>
        		</div> -->
				<div class="card-visits" v-for="card in filterAccess" :key="card.reportTitle">
          			<ReportCard>
						<p slot="card-title" style="text-align: center" class="report-card-title m-0">{{ card.reportTitle }}</p>
						<p slot="card-value" style="text-align: center; font-size: 36px; color: black" class="report-card-value m-0" v-if="card.reportVaue != 0">{{ card.reportValue }}</p>
						<span slot="card-percentage" class="percentage-value">{{ card.conversionRate | toPercentage }}</span>
						<template slot="card-report-list" v-if="card.reportList.length > 0">
							<div class="row mb-3">
								<div class="col-12 text-left">
									<ul class="mt-4">
										<li v-for="item in filterReportListValue(card.reportList)" :key="item.interactionOriginName">
											<strong>{{ item.interactionOriginValue }}</strong> em {{ item.interactionOriginName }}
										</li>
									</ul>
								</div>
							</div>
						</template>
					</ReportCard>
				</div>
			</div>
      		<div class="row text-left mb-4" v-if="topPosts.length > 0">
        		<div class="col-12 mb-3">
          			<hr />
          			<h5>Publicações mais acessadas</h5>
        		</div>
				<div class="col-12 my-2" v-for="(post, index) in filterPostsByIndex" :key="index">
					<div class="row">
						<div class="col-3">
							<img v-if="post.main_image" src="" alt="" />
						</div>
						<div class="col">
							<p class="top-post-title mb-2">Post Title</p>
							<p class="top-post-values">post Values</p>
						</div>
					</div>
				</div>
				<div class="col-12 text-left see-more">
					<span class="pointer" @click="maxPostsToSee += 20">Ver mais</span>
				</div>
      		</div>
    	</div>
	</div>
</template>

<script>
import apiMixins from "@/mixins/apiMixins";
export default {
  	name: "Report",
  	data() {
		return {
			days:this.daysReport,
			blockSelect: false,
      		colorFranchise: "",
      		chartLoaded: false,
      		maxPostsToSee: 3,
      		reportCards: [],
      		reportCharts: [],
      		topPosts: [],
			datechart: " "
		};
  	},
	props: {
		daysReport: {
			required: true,
		},
	},
  	watch: {
	   	days() {
      		this.$emit("days",this.days);
		}
  	},
  	methods: {
		  async getReportData(days) {
			  this.blockSelect = true;
			const siteId = this.$session.get("siteId");
			const url = `/site/${siteId}/report?d=${days}`;
			const dataReport = await this.requestApiData(url, "get");
			if(dataReport.data) {
      		    this.colorFranchise = dataReport.data.mainColor;
      		    this.reportCards = [...dataReport.data.reportCards];
				this.reportCharts = [...dataReport.data.charts];
			}

			this.date();
				setTimeout(() => {
					this.chartLoaded = true
					this.blockSelect = false;
			}, 400);
    	},
		date(){
			const dataAtual = new Date();
			const dia = dataAtual.getDate();
			const mes = dataAtual.getMonth();
			const ano = dataAtual.getFullYear();
			const dateReport = new Date( dataAtual.setDate(dataAtual.getDate() - this.days));
			const diaReport = dateReport.getDate();
			const mesReport = dateReport.getMonth();
			const anoReport = dateReport.getFullYear();
			this.datechart = (diaReport + " " + this.getMesPT(mesReport) + " " + anoReport + " - " + dia + " " + this.getMesPT(mes) + " " + ano);
		},
		getMesPT(mes){
			var ano = ["Jan","Fev","Mar","Abr","Mai","Jun","Jul","Ago","Set","Out","Nov","Dez"]
			return ano[mes]
			},
		filterReportListValue(reportList) {
      		return reportList.filter(item => item.interactionOriginValue > 0);
    	}
  	},
  	computed: {
		filterOpportunities() {
      		return this.reportCards.filter( card => card.reportTitle == "Oportunidades");
    	},
    	filterInteractions() {
      		return this.reportCards.filter(card => card.reportTitle == "Interações");
		},
    	filterAccess() {
      		return this.reportCards.filter(card => card.reportTitle == "Acessos");
		},
    	filterPostsByIndex() {
      		return this.topPosts.slice(0, this.maxPostsToSee);
    	}
  	},
  	filters: {
    	toPercentage(value) {
      		return parseFloat(value) > 0 ? `${value}%` : "";
    	}
  	},
  	components: {
    	ReportCard: () => import("../molecules/ReportCard"),
		ReportChart: () => import("../molecules/ReportChart")
  	},
  	mixins: [apiMixins],
	mounted() {
    	this.getReportData(this.days);
  	}
};
</script>

<style scoped>
.grid-container {
	display: grid;
	grid-template-columns: 1fr 1fr 1fr 1fr;
	grid-template-rows: 15px;
	gap: 15px 15px;
	grid-template-areas:
		"date-chart . . select-chart"
		"chart-area chart-area card-opportunities card-visits"

}

@media all and (max-width: 900px) {
	.grid-container {
		grid-template-columns: 1fr 1fr;
		grid-template-rows: 20px 1fr auto auto;
    	gap: 10px 10px;
		grid-template-areas:
		"date-chart select-chart"
		"chart-area chart-area"
		"card-opportunities card-visits"
		"card-opportunities card-visits";
	}
}

.select-chart {
	grid-area: select-chart;
	text-align: right;
	font-size: 14px;
}

select{
	background-color: transparent;
	border-bottom: none !important;
}

.date-chart {
	grid-area: date-chart;
	text-align: left;
	color: #7c828a;
	font-size: 14px;
	position: absolute;
}

.chart-area {
  	grid-area: chart-area;
}

.card-opportunities {
  	grid-area: card-opportunities;
}

.card-interactions {
  	grid-area: card-interactions;
}

.card-visits {
  	grid-area: card-visits;
}
.top-post-title {
	font-size: 1.2rem;
	font-weight: 700;
}
.top-post-values {
	font-size: 0.65rem;
	color: #ccc;
}
.see-more {
  	color: var(--main-color);
}
</style>



// WEBPACK FOOTER //
// src/components/organisms/Report.vue